export default "__VITE_ASSET__B_mR1VLf__"